
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.053 11.482c0 .288.258.518.545.518h.804c.287 0 .545-.23.545-.518V6.964h4.536c.287 0 .517-.259.517-.547v-.805c0-.288-.23-.547-.517-.547H6.947V.518C6.947.23 6.69 0 6.402 0h-.804c-.287 0-.545.23-.545.518v4.547H.545A.565.565 0 000 5.612v.805c0 .288.258.547.545.547h4.508v4.518z","fill":"#fff"}})])
          )
        }
      }
    